module.exports = __webpack_public_path__ + "static/8-9554ea92d3b7bbfb4e301cda179a7096.jpeg";